import { ApiResponse } from '@marketplace-web/shared/api-client'

import { api } from './api'

export const deleteShippingOrderContact = (shippingOrderId: string) =>
  api.delete<ApiResponse>(`/shipping_orders/${shippingOrderId}/shipping_contact`)
